var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRingNotification2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "var(--primary-button-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4739 17.8615L20.7281 16.6235C20.5715 16.3476 20.4298 15.8255 20.4298 15.5198V13.633C20.4298 11.8804 19.4006 10.3665 17.9166 9.65806C17.5288 8.97196 16.8128 8.54688 15.9925 8.54688C15.1796 8.54688 14.4488 8.98687 14.061 9.68043C12.6067 10.4038 11.6 11.9028 11.6 13.633V15.5198C11.6 15.8255 11.4583 16.3476 11.3017 16.616L10.5484 17.8615C10.2501 18.3611 10.183 18.913 10.3695 19.4201C10.5484 19.9198 10.9735 20.3076 11.5254 20.494C12.9722 20.9862 14.4935 21.2248 16.0149 21.2248C17.5362 21.2248 19.0576 20.9862 20.5044 20.5015C21.0264 20.3299 21.4291 19.9347 21.623 19.4201C21.8169 18.9055 21.7647 18.3387 21.4739 17.8615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1105 21.9762C17.7973 22.8413 16.9695 23.4603 16 23.4603C15.4109 23.4603 14.8292 23.2216 14.419 22.7965C14.1804 22.5728 14.0014 22.2745 13.897 21.9688C13.9939 21.9837 14.0909 21.9911 14.1953 22.006C14.3668 22.0284 14.5458 22.0508 14.7248 22.0657C15.1499 22.103 15.5824 22.1254 16.0149 22.1254C16.44 22.1254 16.8651 22.103 17.2827 22.0657C17.4393 22.0508 17.596 22.0433 17.7451 22.021C17.8644 22.006 17.9838 21.9911 18.1105 21.9762Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRingNotification2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ring-notification2.c06db432.svg";
export { ForwardRef as ReactComponent };